import React, { useEffect, useState } from 'react';
import DataTable from '../../../components/DataTable/DataTable';
import { IColInfo } from '../../../components/DataTable/Interfaces';
import { ApplicationFunctions, useAuth } from '../../../contexts/authContext';
import { useNotifications } from '../../../contexts/notificationContext';
import DataService from "../../../services/data.service";
import { UserProps } from '../../../types/IdProps';
import AddUserAttachmentPopup from '../Popups/User_popup_AddAttachment';

const User_tab_Attachments: React.FC<UserProps> = ({ userId }) => {
    const [data, setData] = useState<any[]>();
    const [showPopup, setShowPopup] = useState<boolean>(false)
    const { handleResult, handleException } = useNotifications();
    const { isAuthorizedForAttachmentType } = useAuth();

    useEffect(() => {
        getTableData();
    }, [userId]);

    function getTableData() {
        DataService.get<any[]>('api/v1/UserAttachments/ByUser/' + userId)
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/UserAttachments/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    function canDeleteRow(row): boolean {
        if (row.attachment.attachmentType.canDelete && isAuthorizedForAttachmentType(ApplicationFunctions.DeleteAttachment, row.attachment.attachmentTypeId))
            return true

        return false;
    }

    const colInfos: IColInfo[] = [
        { key: true, dataProp: 'attachmentId', visible: false },
        { title: 'Name', dataProp: 'attachment', dataType: 'thumbnail', sort: 'asc' },
        { title: 'Type', dataProp: 'attachment.attachmentType.name' },
        { title: 'Version', dataProp: 'attachment.latestVersion', dataType: 'number', width: 100 },
        { title: 'Created on', dataProp: 'attachment.createdOn', dataType: 'datetime' },
        { title: 'Created by', dataProp: 'attachment.createdByUser', dataType: 'user' }
    ];

    if (isAuthorizedForAttachmentType(ApplicationFunctions.CreateAttachment) || isAuthorizedForAttachmentType(ApplicationFunctions.DeleteAttachment)) {
        colInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => setShowPopup(true) }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow, isVisible: canDeleteRow }]
            }
        );
    }

    return (
        <>
            {data && (
                <DataTable
                    name='dtProjectAttachments'
                    colInfos={colInfos}
                    tableData={data}
                    navigateTitle='Attachment'
                    navigateUrl='/plm/Common/Attachment/'
                />
            )}
            <AddUserAttachmentPopup userId={userId} show={showPopup} onHide={() => { setShowPopup(false); getTableData(); }} />
        </>
    );
}
export default User_tab_Attachments;